<script setup>
const props = defineProps({
  id: {
    required: true,
    type: String,
  },
  linkActive: {
    required: true,
    type: Boolean,
  },
});
const ariaDisabled = props.linkActive ? null : 'true';
const href = props.linkActive ? `#trigger-${props.id}` : null;
const roleLink = props.linkActive ? null : 'link';
const tabindex = props.linkActive ? null : '-1';
</script>

<template>
  <a :aria-disabled="ariaDisabled" :href="href" :role="roleLink" :tabindex="tabindex">
    <slot />
  </a>
</template>
